import React from 'react';
import ReactDOM from 'react-dom';
import Calculator from './components/Calculator';
import Footer from './components/Footer';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
  <div className="page-container">
    <div className="content-wrap">
      <Calculator />
    </div>
    <Footer />
  </div>
  </React.StrictMode>,
  document.getElementById('root')
);

